export default __webpack_public_path__ + "static/media/cheatday_1@2x.069cfbfa.jpg";